<template>
  <div>
    <div class="bg" v-if="isShow"></div>
    <div class="modalPage" :class="{on: isShow}" style="width: 100rem;">
      <!--header-->
      <header class="header">
        <div class="header__inner type_02">
          <h2 class="header__ttl">개인정보 활용 동의 약관</h2>
          <div class="header__btns">
            <button @click="fnClose()">닫기</button>
          </div>
        </div>
      </header>
      <!--main-->
      <main class="main" role="main" style="background: white;">
        <div class="main__inner"><!-- 배경: bg-->
          <div class="main__con">
            <div class="sign__page" style="padding: 1rem;">
              <h4>여러분의 소중한 개인정보는 KS에너지가 여러분에게 더 나은 서비스를 제공하기 위해 활용됩니다.</h4>
              <p>KS에너지는 서비스를 원활하게 제공하고 더욱 향상된 이용자 경험을 드리기 위해 필요한 여러분의 개인정보를 수집합니다.</p>
              <p>즉, 여러분이 동의한 이용약관에 따라 서비스의 기본 기능이나 여러 특화된 기능을 제공하기 위해서는 여러분의 본인 여부나 연령, 계정이나 연락처 및 사용기기의 확인이 필요한 경우가 있습니다.</p>
              <p>또한, 여러분에게 개별적으로 알려 드릴 사항이 있는 때나, 서비스 이용과 관련하여 문의나 분쟁이 있는 경우, 유료서비스 이용 시 컨텐츠 등의 전송이나 배송∙요금 정산을 위해서도 필요합니다.</p>
              <p>그 외에도, 새로운 서비스 개발 및 특화, 맞춤형 서비스 제공, 기능개선, 인구통계학적 특성에 따른 서비스 제공, 각종 이벤트나 광고성 정보의 제공, 법령 등에 규정된 의무의 이행, 법령이나 이용약관에 반하여 여러분에게 피해를 줄 수 있는
                잘못된 이용행위의 방지를 위해서도 여러분의 개인정보가 활용됩니다.</p>

              <h4>KS에너지가 더 나은 서비스를 제공해 드리기 위해 수집하는 여러분의 개인정보는 아래와 같습니다.</h4>
              <p>KS에너지는 여러분이 서비스에 처음 가입할 때 또는 서비스를 이용하는 과정에서 홈페이지 또는 서비스 내 개별 어플리케이션이나 프로그램 등을 통하여 여러분의 이메일, 휴대폰번호, 스마트폰 등 단말기 주소록 내에 저장된 연락처
                정보(제3자의 전화번호, 이름), 이용자 이름(닉네임)이 수집되며, 성별, 서비스 아이디, 사진(메타정보 포함)이 선택적으로 수집됩니다.</p>
              <p>또한, 서비스 이용과정이나 사업처리 과정에서 단말기정보(OS, 화면사이즈, 디바이스 아이디), IP주소, 쿠키 정보가 자동으로 생성되어 수집될 수 있습니다.</p>
              <p>그 외에도 여러분이 유료 서비스를 이용하는 과정에서 결제 등을 위하여 불가피하게 필요한 때에는 신용카드 정보와 같이 결제에 필요한 정보가 수집될 수 있습니다.</p>
              <p>KS에너지는 수집하는 개인정보에 대하여 여러분의 동의를 받고 서비스를 제공하게 됩니다.</p>
              <p>KS에너지는 여러분의 별도 동의가 있는 경우나 법령에 규정된 경우를 제외하고는 여러분의 개인정보를 절대 제3자에게 제공하지 않습니다.</p>
              <p>KS에너지는 여러분이 서비스 이용과정 등에서 따로 동의하는 경우나 법령에 규정된 경우를 제외하고는 여러분의 개인정보를 위에서 말씀 드린 목적 범위를 초과하여 이용하거나 제3자에게 제공 또는 공유하지 않습니다.</p>
              <p>KS에너지에 제3자의 서비스가 연결되어 제공되는 경우 서비스 이용을 위해 필요한 범위 내에서 여러분의 동의를 얻은 후에 개인정보를 제 3자에게 제공하여, 서비스의 원활한 제공을 위해 필요한 때에는 개인정보의 취급을 위탁하기도
                합니다.</p>

              <div class="terms-footer">
                <p>개인정보관리책임자</p>
                <p>이름: 현지훈</p>
                <p>연락처: 1588-9138</p>
                <p>공고일자: 2021년 10월 01일</p>
                <p>시행일자: 2021년 10월 01일</p>
                <p class="description">
                  KS에너지는 법률이나 서비스의 변경사항을 반영하기 위한 목적 등으로 개인정보 취급방침을 수정할 수 있습니다.<br>
                  개인정보 취급방침이 변경되는 경우 KS에너지는 변경 사항을 게시하며, 변경된 개인정보 취급방침은 게시한 날로부터 7일 후부터 효력이 발생합니다.<br>
                  하지만, 피치 못하게 여러분의 권리에 중요한 변경이 있을 경우 변경될 내용을 30일 전에 미리 알려드리겠습니다.
                </p>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  </div>
</template>
<script>
export default {
  name: 'terms-privacy-modal',
  props: {
    callBack: {
      type: [Function]
    },
    isShow: {}
  },
  created: function () {
  },
  methods: {
    fnClose: function () {
      this.$emit('eventClose')
    },
    fnSelectAddress: function (item) {
      if (this.callBack !== undefined && this.callBack !== null) {
        this.callBack(item)
        this.$emit('eventClose', -2)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.bg {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: black;
  opacity: 0.7;
  z-index: 100;
}

.sign__page {
  max-height: 40rem;
  overflow: auto;
  h4 {
    font-size: 1.2rem;
    line-height: 2.4rem;
  }

  p {
    font-size: 1rem;
    line-height: 1.2rem;
    margin-bottom: 0.4rem;
  }

  .terms-footer {
    background-color: #eeeeee;
    padding: 1rem;
    border-radius: 0.4rem;

    p.description {
      font-size: 0.8rem;
      font-weight: bold;
    }
  }
}

.header {
  background-color: white;
  padding: 1rem;

  h2 {
    display: inline-block;
    vertical-align: top;
    width: 50%;
  }

  .header__btns {
    display: inline-block;
    vertical-align: top;
    width: 50%;
    text-align: right;

    button {
      background: none;
      font-size: 14px;
      font-weight: bold;
      border: 0;
      cursor: pointer;
    }
  }
}

.modalPage {
  position: fixed;
  //transition-property: top;
  //transition-duration: 0s;
  //transition-delay: 0s;
  top: 100vh;
  max-width: 70rem;
  left: 47%;
  margin-left: -30rem;
  z-index: 100;
  border: 2px solid #E1E1E1;
  border-radius: 7px;
  overflow: hidden;
}

.modalPage.on {
  transition-property: top;
  transition-duration: 0.5s;
  transition-delay: 0s;
  top: 5rem;
}
</style>
